import { NtapGlobalConstants, Util } from '@ntap/core';

export class NestedViewStrategy {
  public static attrNameToViewName(attrName: string) {
    const viewName = attrName.replace(/~/g, '_');

    return viewName;
  }

  public static viewNameFromParentAttr(attributeMetadata: { name: string }) {
    return NestedViewStrategy.attrNameToViewName(attributeMetadata.name);
  }

  public static viewStateFromParentItem(
    attributeMetadata: { name: string },
    item: any
  ) {
    let currentViewState = {};
    const itemMainType = attributeMetadata.name.substring(
      0,
      attributeMetadata.name.lastIndexOf('~')
    );
    const relatedAttrName = Util.getFullAttrName(
      itemMainType,
      NtapGlobalConstants.ATTR_id
    );
    const itemId =
      item[Util.getFullAttrName(itemMainType, NtapGlobalConstants.ATTR_id)];
    currentViewState = {
      $parentId: itemId,
      $parentType: itemMainType,
      [relatedAttrName]: itemId
    };

    return currentViewState;
  }
}
